module.exports = __webpack_public_path__ + "2b33192feb775f7db014b7cc2f4a4772.png";